import { useEffect, useState } from "react";
import ReactJson from "react18-json-view";
import * as rpc from "@1games-ru/rage-rpc";
import { Button, Card } from "@radix-ui/themes";
import { EventCefDebugMessage } from "@/domains/dev/contentViewer/interfaces/contentViewerTypes.ts";

function ContentViewerContainer() {
  const [messages, setMessages] = useState<EventCefDebugMessage[]>([]);

  const addMessage = (message: EventCefDebugMessage): void => {
    const targetMessage = { ...message };
    const nm = [targetMessage, ...messages];
    console.log({ nm, messages });
    setMessages(nm);
  };

  useEffect(() => {
    const handler = (message: EventCefDebugMessage) => {
      console.log({ message });

      addMessage(message);
    };

    console.log("DevCefContentViewer.register");
    rpc.register("DebugDataClientToCef", handler);

    return () => {
      console.log("DevCefContentViewer.unregister");
      rpc.off("DebugDataClientToCef", handler);
    };
  }, [addMessage]);

  const flush = () => setMessages([]);
  const remove = (message: { uid: string }) => {
    const index = messages.findIndex((m: { uid: string }): boolean => m.uid === message.uid);

    if (index === -1) {
      return;
    }

    const targetMessages = [...messages];
    targetMessages.splice(index, 1);

    setMessages(targetMessages);
  };

  console.log({ messages });

  return (
    <Card
      className="fixed bottom-10  right-10 p-5 w-[23rem] pr-0"
      variant="solid-surface-gradient"
    >
      <div className="overflow-y-scroll overflow-x-hidden h-[30rem] pr-4">
        <div className="grid grid-cols-12 gap-3">
          <div className="col-span-full">
            <div className="mb-4">
              <Button size="3" type="button" className="w-full" onClick={flush} color="red">
                Очистить [{messages.length}]
              </Button>
            </div>

            {messages.length === 0 ? (
              <div className="flex flex-col justify-center h-[20em] text-center">
                <div>n/a messages</div>
              </div>
            ) : (
              ""
            )}

            {messages.map((message, i) => {
              return (
                <div key={String(message.eventName) + String(message.uid)} className="mb-4">
                  <div className="text-center font-bold mb-1">
                    <span>
                      {message.eventName} {message.uid} &nbsp;&nbsp;
                    </span>
                    <span onClick={() => remove(message)}>x</span>
                  </div>

                  <div>
                    <ReactJson src={message.content} theme="default" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Card>
  );
}

export default ContentViewerContainer;
